import { FC, ReactElement, useEffect, useRef, useState } from 'react'
import { Table, Button } from 'react-bootstrap'
import ShipToAddressSearch from './ShipToAddressSearch'
import { CustomerModel } from 'shared/models/CutomerDeliveryLocations/CustomerModel'
import { DeliveryLocationModel } from 'shared/models/CutomerDeliveryLocations/DeliveryLocationModel'
import { VestigingEnum } from 'shared/models/Enum'
import { ILocatieGlnModel } from 'shared/models/ILocatieGlnModel'
import { IModalReference } from 'shared/models/References'

interface IShipToViewProps {
  customer: CustomerModel
  location: ILocatieGlnModel
  existingLocation: DeliveryLocationModel
  warehouse: VestigingEnum
  onShipToAddressChanged: (
    customer: CustomerModel,
    location: ILocatieGlnModel
  ) => void
}
const ShipToView: FC<IShipToViewProps> = (
  props: IShipToViewProps
): ReactElement => {
  const addressSearchViewRef = useRef<IModalReference>()
  const [customer, setCustomer] = useState<CustomerModel>()
  const [location, setLocation] = useState<ILocatieGlnModel>()
  const [existingLocation, setExistingLocation] =
    useState<DeliveryLocationModel>()

  useEffect(() => {
    setCustomer(props.customer)
    setLocation(props.location)
    setExistingLocation(props.existingLocation)
    if (props.existingLocation.shiptolocationid === 0) {
      showAddressSearchView() //eerst locatie kiezen
    }
    console.log('shiptoview init')
  }, [])

  const onAddressChanged = (newLocation: ILocatieGlnModel) => {
    existingLocation.shiptocustomergln = customer.customerEanCode.toString()
    existingLocation.shiptolocationgln = newLocation.locatieGlnCode.toString()
    existingLocation.shiptolocationname = newLocation.locatieGlnNaam
    existingLocation.shiptowarehousename =
      VestigingEnum[newLocation.vestigingCode]
    setExistingLocation(existingLocation)

    setLocation(newLocation)
    if (props.onShipToAddressChanged) {
      props.onShipToAddressChanged(props.customer, newLocation)
    }
  }

  const showAddressSearchView = () => {
    addressSearchViewRef.current.show()
  }

  /**
   * Assuming this component is being used in a table.
   */
  return (
    <>
      <tr className='border'>
        <td>
          <h5>Ship-to</h5>
        </td>
        <td>
          <Table borderless={true} size='sm'>
            <tbody>
              <tr>
                <td className='font-weight-bold text-right'>Klant{'  '}</td>
                <td>{customer?.customerNumber}</td>
                <td className='font-weight-bold text-right'>Klant Gln</td>
                <td>{customer?.customerEanCode}</td>
              </tr>
              <tr>
                <td className='font-weight-bold text-right'>
                  Klant Naam{'  '}
                </td>
                <td>{customer?.customerName}</td>
              </tr>
              <tr>
                <td className='font-weight-bold text-right'>
                  Locatie Naam{'  '}
                </td>
                <td>
                  {props?.existingLocation?.shiptolocationname ??
                    'Geen gegevens'}
                </td>
                <td className='font-weight-bold text-right'>Locatie Gln</td>
                <td>
                  {props?.existingLocation?.shiptolocationgln ??
                    'Geen gegevens'}
                </td>
              </tr>
              <tr>
                <td className='font-weight-bold text-right'>Vestiging{'  '}</td>
                <td>
                  {props?.existingLocation?.shiptowarehousename ??
                    'Geen gegevens'}
                </td>
              </tr>
            </tbody>
          </Table>
        </td>
        <td>
          <Button
            variant='primary'
            onClick={showAddressSearchView}
            className='float-right'
          >
            Wijzig
          </Button>
        </td>
      </tr>

      <ShipToAddressSearch
        ref={addressSearchViewRef}
        onLinkedAddress={onAddressChanged}
        warehouse={location?.vestigingCode ?? props.warehouse}
        customer={props.customer}
      />
    </>
  )
}

export default ShipToView
